export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-like-98f205bf15234af6f18c024acd077371.svg";